import { FC } from 'react';

import Button from 'components/_core/Button';
import SunshineCard from 'components/_core/SunshineCard';
import Text from 'components/_core/Text';

import locales from './locales';

interface UploadCardProps {
  onClick: () => void;
}

const UploadCard: FC<UploadCardProps> = ({ onClick }) => (
  <SunshineCard onClick={onClick}>
    <Text>{locales.description}</Text>

    <Button
      icon="download"
      onClick={onClick}
      tabIndex={-1}
      variant="inline-secondary"
    >
      {locales.addLogo}
    </Button>
  </SunshineCard>
);

export default UploadCard;
